import Scrollspy from "react-scrollspy";
import logoXrai from "../assets/images/logo/xrailogo.png";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getCookie, removeCookie } from "../util/Cookie";
import { TokenName, haderLogout } from "../util/Common";
import { useSetRecoilState } from "recoil";
import { apiKeyState } from "../atom/ApiKey";
import { apiProductsState } from "../atom/Products";
import { useEffect, useState } from "react";
import { FiChevronUp, FiX, FiMenu } from "react-icons/fi";
import { ListJoinState } from "../atom/BorderPage";

export const Header = () => {
  const history = useHistory();
  const [isToken, setToken] = useState(false);
  const setApiKeys = useSetRecoilState(apiKeyState);
  const setPriducts = useSetRecoilState(apiProductsState);
  const logo = {
    // width: "20%",
    width: `150px`,
  };

  useEffect(() => {
    const token = getCookie(TokenName);

    if (!token) {
      setToken(true);
    } else {
      setToken(false);
    }
  }, []);
  const setListJoinState = useSetRecoilState(ListJoinState);

  const haderLogout = () => {
    localStorage.clear();
    setApiKeys([]);
    setPriducts([]);
    setListJoinState([]);
    removeCookie(TokenName);
    history.push("/login");
  };
  const menuTrigger = () => {
    document.querySelector(".header-wrapper").classList.toggle("menu-open");
  };

  const closeMenuTrigger = () => {
    document.querySelector(".header-wrapper").classList.remove("menu-open");
  };

  return (
    <header className="header-area formobile-menu header--fixed default-color">
      <div className="header-wrapper" id="header-wrapper">
        <div className="header-left">
          <div className="logo">
            <a href="/">
              <img
                className="logo-1"
                style={logo}
                src={logoXrai}
                alt="Logo Images"
              />
              <img className="logo-2" src={logoXrai} alt="Logo Images" />
            </a>
          </div>
        </div>
        <div className="header-right">
          <nav className="mainmenunav d-lg-block">
            <Scrollspy
              className="mainmenu"
              items={["home", "border", "contact"]}
              // currentClassName="is-current"
              offset={-200}
            >
              <li>
                <a
                  style={{
                    cursor: `pointer`,
                  }}
                  onClick={() => history.push("/")}
                >
                  Home
                </a>
              </li>
              <li>
                <a href="/#company">Company</a>
              </li>
              <li>
                <a href="/#solution">Solution</a>
              </li>
              <li>
                <a href="/#portfolio">Portfolio</a>
              </li>

              <li>
                <a
                  style={{
                    color: `#ffc20e`,
                    cursor: `pointer`,
                  }}
                >
                  Contact
                  <hr
                    color={`#ffc20e`}
                    style={{
                      height: `4px`,
                    }}
                  />
                </a>
              </li>
              <li>
                {isToken === true ? (
                  <a href="login">Login</a>
                ) : (
                  <a
                    style={{
                      cursor: `pointer`,
                    }}
                    onClick={() => haderLogout()}
                  >
                    Logout
                  </a>
                )}
              </li>
            </Scrollspy>
          </nav>
          {/* <div className="header-btn">
              <a
                className="rn-btn"
                href="https://themeforest.net/checkout/from_item/25457315?license=regular"
              >
                <span>buy now</span>
              </a>
            </div> */}
          {/* Start Humberger Menu  */}
          <div className="humberger-menu d-block d-lg-none pl--20">
            <span onClick={menuTrigger} className="menutrigger text-white">
              <FiMenu />
            </span>
          </div>
          {/* End Humberger Menu  */}
          <div className="close-menu d-block d-lg-none">
            <span onClick={closeMenuTrigger} className="closeTrigger">
              <FiX />
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};
